// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"297":"c936ca2f","319":"c033b712","596":"88072cdd","721":"a4a83f82","983":"e46b14f5"}[chunkId] + ".chunk.js";
};